import {
  GlobeAltIcon,
  MapPinIcon,
  PhoneIcon,
} from '@heroicons/react/24/outline';
import { mapHref } from '@retainerclub/common';
import { useReferral } from '@retainerclub/hooks';
import { formatPhoneNumber } from 'react-phone-number-input';

function OnboardingFormHeader() {
  const { partnerLocation } = useReferral();

  return (
    <div className="z-10 mx-auto w-full max-w-full px-8 sm:px-8 md:max-w-5xl lg:px-0">
      <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex-1">
          <h2 className="font-bold font-oswald text-black text-xl uppercase">
            Welcome to Retainer Club
          </h2>
          <div className="my-2 w-1/4 border-black border-b-4 py-1" />
          <h1 className="mt-4 font-bold text-5xl text-white">
            Simple Retainer
            <br />
            Replacement
          </h1>
          <p className="mt-4 font-normal text-black/90 text-lg leading-7 drop-shadow-2xl">
            You&apos;re one step closer to easy, online retainer replacement.
            <br />
            Create your Retainer Club account to get started today.
          </p>
        </div>
        <div>
          {partnerLocation && (
            <div className="flex-shrink-0 lg:max-w-sm">
              <div className="flex flex-row gap-6">
                {partnerLocation.imageUrl && (
                  <div className="size-28 flex-shrink-0 rounded-lg bg-white">
                    <img
                      className="size-full rounded-lg object-cover"
                      src={partnerLocation.imageUrl}
                      alt={partnerLocation.name}
                    />
                  </div>
                )}
                <div className="flex flex-col items-start gap-2">
                  <div className="min-w-0 flex-1">
                    <p className="-mt-1 font-medium text-black text-sm">
                      Your Provider
                    </p>
                    <h3 className="font-bold text-base text-white leading-tight">
                      {partnerLocation.name}
                    </h3>
                  </div>
                  <div className="space-y-2">
                    {partnerLocation.address && (
                      <div className="flex items-start gap-2">
                        <MapPinIcon
                          className="mt-0.5 size-4 flex-shrink-0 text-gray-100"
                          aria-hidden="true"
                        />
                        <div className="text-xs leading-relaxed">
                          <a
                            href={mapHref(null, null, partnerLocation.address)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-black text-xs hover:text-white"
                          >
                            <div>{partnerLocation.address.address}</div>
                            {partnerLocation.address.address2 && (
                              <div>{partnerLocation.address.address2}</div>
                            )}
                            <div>
                              {partnerLocation.address.city},{' '}
                              {partnerLocation.address.region}{' '}
                              {partnerLocation.address.postalCode}
                            </div>
                          </a>
                        </div>
                      </div>
                    )}

                    <div className="flex items-center gap-4">
                      {partnerLocation.phone && (
                        <div className="flex items-center gap-1">
                          <PhoneIcon
                            className="size-4 flex-shrink-0 text-gray-100"
                            aria-hidden="true"
                          />
                          <a
                            href={`tel:${partnerLocation.phone}`}
                            className="text-black text-xs hover:text-white"
                          >
                            {formatPhoneNumber(partnerLocation.phone)}
                          </a>
                        </div>
                      )}

                      {partnerLocation.website && (
                        <div className="flex items-center gap-1">
                          <GlobeAltIcon
                            className="size-4 flex-shrink-0 text-gray-100"
                            aria-hidden="true"
                          />
                          <a
                            href={`//${partnerLocation.website}`}
                            className="text-black text-xs hover:text-white"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Website
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default OnboardingFormHeader;
